import VyhlasenieOPristupnosti from './VyhlasenieOPristupnosti';

export default VyhlasenieOPristupnosti;
